export default {
    path: '/spare',
    component: () => import('@/views/layout.vue'),
    redirect: '/spare',
    name: 'spare',
    sort: 6,
    icon: 'el-icon-takeaway-box',
    // meta: { title: 'demo.menu.SpareParts' , authCode: ['SPARE001']},
    meta: { title: 'demo.menu.SpareParts'},
    children: [
        {
            path: '/factorySparePart',
            name: 'factorySparePart',
            component: () => import('@/views/permission/spare/factorySparePart.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.factorySparePart',
                // authCode: ['SPAREINFO001']
            }
        },
        {
            path: '/sparePartInfo',
            name: 'sparePartInfo',
            component: () => import('@/views/permission/spare/sparePartInfo.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.SpareAccount',
                authCode: ['SPAREINFO001']
            }
        },
        {
            path: '/sparePartClassify',
            name: 'sparePartClassify',
            component: () => import('@/views/permission/spare/sparePartClassify.vue'),
            meta: {
                title: 'demo.menu.SpareType',
                authCode: ['SPAREINFO002']
            }
        },
        {
            path: '/sparePartStoreHouse',
            name: 'sparePartStoreHouse',
            component: () => import('@/views/permission/spare/sparePartStoreHouse.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.SpareStore',
                authCode: ['SPAREINFO003']
            }
        },
        {
            path: '/sparePartStockOrder',
            name: 'sparePartStockOrder',
            component: () => import('@/views/permission/spare/sparePartStockOrder.vue'),
            meta: {
                title: 'demo.menu.SpareStock',
                authCode: ['SPAREINFO004']
            }
        },
        {
            path: '/spareProcurement',
            name: 'spareProcurement',
            component: () => import('@/views/permission/spare/spareProcurement.vue'),
            meta: {
                title: 'demo.menu.SparePurchase',
                authCode: ['SPAREINFO005']
            }
        },
        {
            path: '/sparePartPurchaseOrder',
            name: 'sparePartPurchaseOrder',
            component: () => import('@/views/permission/spare/sparePartPurchaseOrder.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.SpareWarehouse',
                authCode: ['SPAREINFO006']
            }
        },
        {
            path: '/sparePartDeliveryOrder',
            name: 'sparePartDeliveryOrder',
            component: () => import('@/views/permission/spare/sparePartDeliveryOrder.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.SpareIssue',
                authCode: ['SPAREINFO007']
            }
        },
        {
            path: '/sparePartsWarehousing',
            name: 'sparePartsWarehousing',
            component: () => import('@/views/permission/spare/sparePartsWarehousing.vue'),
            meta: {
                keepAlive: true,
                title: 'demo.menu.SpareRecord',
                authCode: ['SPAREPARTSWAREHOUSINGRECORD']
            }
        },
        {
            path: '/sparePartPosition',
            name: 'sparePartPosition',
            hidden: true,
            component: () => import('@/views/permission/spare/sparePartPosition.vue'),
            meta: {
                title: 'demo.menu.SpareLocation'
            }
        },
        {
            path: '/addSparePartInfo',
            name: 'addSparePartInfo',
            hidden: true,
            component: () => import('@/views/permission/spare/addSparePartInfo.vue'),
            meta: {
                title: 'demo.menu.SpareEdit',
            }
        },
        {
            path: '/addPartPurchaseOrder',
            name: 'addPartPurchaseOrder',
            hidden: true,
            component: () => import('@/views/permission/spare/addPartPurchaseOrder.vue'),
            meta: {
                title: 'demo.menu.AddReceiptOrder',
            }
        },
        {
            path: '/addPartDeliveryOrder',
            name: 'addPartDeliveryOrder',
            hidden: true,
            component: () => import('@/views/permission/spare/addPartDeliveryOrder.vue'),
            meta: {
                title: 'demo.menu.AddDeliveryOrder',
            }
        }
    ]
}
